var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEdisKontakte = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 85 85",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    stroke: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M31.148 14c-.653 0-1.257.26-1.72.748-6.334 6.689-5.857 19.66 1.215 33.047C37.698 61.15 47.7 68.077 56.127 65.435c.667-.207 1.214-.716 1.543-1.431a3.48 3.48 0 0 0 .04-2.784 313.215 313.215 0 0 0-4.847-10.764c-.305-.644-.85-1.098-1.493-1.242-.63-.143-1.296.025-1.825.459-1.376 1.132-3.05 2.23-5.042 1.832-2.387-.48-4.712-3-7.317-7.931-2.613-4.948-3.443-8.404-2.61-10.877.68-2.022 2.369-3.036 3.929-3.761.61-.284 1.083-.84 1.297-1.523a2.63 2.63 0 0 0-.23-2.116 307.124 307.124 0 0 0-6.105-9.971c-.476-.745-1.255-1.236-2.081-1.315a2.383 2.383 0 0 0-.238-.011M52.49 66.988c-7.925 0-16.491-6.914-22.732-18.726-7.275-13.772-7.69-27.197-1.055-34.201a3.359 3.359 0 0 1 2.777-1.045c1.13.107 2.189.769 2.829 1.77a307.393 307.393 0 0 1 6.126 10.005c.512.872.629 1.936.322 2.919-.297.954-.964 1.73-1.83 2.133-1.37.636-2.842 1.51-3.403 3.173-.73 2.165.103 5.466 2.547 10.09 2.419 4.582 4.588 7.008 6.63 7.418 1.572.326 3.015-.64 4.21-1.623.767-.63 1.742-.874 2.677-.663.948.212 1.742.866 2.179 1.79a315.267 315.267 0 0 1 4.864 10.799 4.496 4.496 0 0 1-.052 3.595c-.45.975-1.214 1.675-2.153 1.969a13.148 13.148 0 0 1-3.936.597"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdisKontakte, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edis-kontakte.094022cc.svg";
export { ForwardRef as ReactComponent };